import { Center, Loader } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from 'configs/routes';
import { userStore } from 'stores/global/RootStore';

/* HOC для страниц, для которых нужна НЕ авторизация */
export const withNotAuth = <P extends Record<string, unknown>>(Component: React.ComponentType<P>) =>
  observer((props: P) => {
    const navigate = useNavigate();
    const {
      user,
      loadingStage: { isSuccess, isLoading, isNotStarted },
      fetchUser,
    } = userStore;

    React.useEffect(() => {
      if (isNotStarted) {
        fetchUser();
      }
    }, [user, fetchUser, isNotStarted]);

    React.useEffect(() => {
      if (isSuccess) {
        navigate(ROUTES.lk.create());
      }
    }, [navigate, isSuccess]);

    if (isNotStarted || isLoading || isSuccess) {
      return (
        <Center>
          <Loader />
        </Center>
      );
    }

    return <Component {...props} />;
  });
